export default {
  details: '/api/v1/account/user',
  logout: '/api/v1/logout',
  confirmationEmailLink: '/account/send/verification/mail',
  dismissNoonNotification: '/api/v1/managers/purchases/v2/dismiss-noon-notification',
};
